import { grpcClientFactory } from './grpcClientFactory';
class PolygonSurfaceAreaService {
    createAuthenticatedClient() {
        return grpcClientFactory.createAuthenticatedUserProjectsClient({ enableCompression: true });
    }
    async calculate(request) {
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated');
        }
        return new Promise((resolve, reject) => {
            try {
                const Req = proto.landscope.mapviewer.v1.CalculatePolygonSurfaceAreaRequest;
                const grpcReq = new Req();
                grpcReq.setProjectId(request.projectId);
                grpcReq.setPolygonGeojson(request.polygonGeojson);
                grpcReq.setPlanarAreaM2(request.planarAreaM2);
                const client = this.createAuthenticatedClient();
                const metadata = { 'authorization': `Bearer ${sessionId}|${sessionToken}` };
                client.calculatePolygonSurfaceArea(grpcReq, metadata, (err, resp) => {
                    if (err) {
                        reject(new Error(`Failed to calculate polygon surface area: ${err.message}`));
                        return;
                    }
                    if (!resp) {
                        reject(new Error('No response received'));
                        return;
                    }
                    resolve({
                        planarAreaM2: resp.getPlanarAreaM2() || 0,
                        surfaceAreaM2: resp.getSurfaceAreaM2() || 0,
                        coveredFraction: resp.getCoveredFraction() || 0,
                    });
                });
            }
            catch (e) {
                reject(new Error(`Failed to calculate polygon surface area: ${e}`));
            }
        });
    }
}
export const polygonSurfaceAreaService = new PolygonSurfaceAreaService();
